import { Body_add_your_food_api_v1_meals_your_food_post } from "@/clients/models/Body_add_your_food_api_v1_meals_your_food_post";

export const EXTRA_FOOD_DEFAULT_MEAL_TIME =
  Body_add_your_food_api_v1_meals_your_food_post.meal_time.SNACK;

export const RECIPE_PROCESSING_SOURCE_EXTRA_FOOD = "extra-food";
export const RECIPE_PROCESSING_SOURCE_ADD_TO_MEAL_TIME = "add-to-meal-time";
